<template>
  <div>
    <transition
      name="fade"
      mode="out-in"
    >
      <b-tabs
        v-if="certificationData"
        vertical
        content-class="col-12 col-md-9 mt-1 mt-md-0"
        pills
        nav-wrapper-class="col-md-3 col-12"
        nav-class="nav-left"
        lazy
      >
        <b-tab :active="activeDetailTab === 'info'">
          <template #title>
            <feather-icon
              icon="InfoIcon"
              size="18"
              class="mr-50"
            />
            <span class="font-weight-bold">Informacje o certyfikacji</span>
          </template>
          <certifications-tab-info
            :certification-data="certificationData"
            @refetch-data="fetchData"
          />
        </b-tab>
        <b-tab
          v-if="detailTabs.enrolments"
          :active="activeDetailTab === 'enrolments'"
        >
          <template #title>
            <feather-icon
              icon="UsersIcon"
              size="18"
              class="mr-50"
            />
            <span class="font-weight-bold">Uczestnicy i wyniki</span>
          </template>
          <certifications-tab-enrolments
            :certification-data="certificationData"
            @refetch-data="fetchData"
          />
        </b-tab>
        <b-tab
          v-if="detailTabs.invoices"
          :active="activeDetailTab === 'invoices'"
        >
          <template #title>
            <feather-icon
              icon="FileTextIcon"
              size="18"
              class="mr-50"
            />
            <span class="font-weight-bold">Faktury</span>
          </template>
          <certifications-tab-invoices
            :certification-data="certificationData"
          />
        </b-tab>
      </b-tabs>
      <div
        v-else
        class="text-center"
      >
        <b-spinner style="width: 4em; height: 4em" />
      </div>
    </transition>
  </div>
</template>

<script>
import {
  BTabs, BTab, BSpinner,
} from 'bootstrap-vue'
import resolveCertificationKind from '@/helpers/resolveCertificationKind'
import {
  certificationDetailTabVisibility,
  isUserEnrolledOnCertification,
  resolveCertificationDetailTab,
} from '@/helpers/certification/certificationDetailsLogic'
import CertificationsTabInfo from './CertificationsTabInfo.vue'
import CertificationsTabEnrolments from './CertificationsTabEnrolments.vue'
import CertificationsTabInvoices from './CertificationsTabInvoices.vue'

export default {
  components: {
    BTabs,
    BTab,
    BSpinner,
    CertificationsTabInfo,
    CertificationsTabEnrolments,
    CertificationsTabInvoices,
  },
  data() {
    return {
      certificationData: null,
    }
  },
  computed: {
    detailTabs() {
      return certificationDetailTabVisibility({
        isAdmin: this.isAdmin,
        isManager: this.isManager,
        isTrainer: this.isTrainer,
        isFordPoland: this.isFordPoland,
        isEmployee: this.isEmployee,
        isCurrentUserEnrolled: isUserEnrolledOnCertification(
          this.certificationData,
          this.currentUser && this.currentUser.id,
        ),
      })
    },
    activeDetailTab() {
      return resolveCertificationDetailTab(this.$route.query.tab, this.detailTabs)
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.fetchData()
        }
      },
    },
  },
  beforeMount() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch('certification/fetchCertification', {
        id: this.$route.params.id,
      }).then(response => {
        if (response && response.status === 200) {
          this.certificationData = response.data
          this.$root.$emit('pageTitle:set', `Certyfikacja ${resolveCertificationKind(this.certificationData.kind)}`)
        } else {
          this.$router.replace('/certifications/list')
          // this.$root.$emit('global:error', 'Nie znaleziono terminu certyfikacji.')
        }
      })
    },
  },
}
</script>
